import type { ReactNode } from 'react';

function isPropertyTypeNA(raw: string): boolean {
  const t = raw.trim().toLowerCase();
  return t === 'n/a' || t === 'n a' || t === 'na';
}

function isPlaceholderDash(raw: string): boolean {
  const t = raw.trim();
  return t === '—' || t === '-' || t === '–';
}

/** Renders property type, or italic "See MLS #" when value is empty or N/A. */
export function propertyTypeCell(
  propertyType: string | null | undefined
): ReactNode {
  const t = propertyType?.trim() ?? '';
  if (!t || isPropertyTypeNA(t) || isPlaceholderDash(t)) {
    return <span className="italic text-slate-600">See MLS #</span>;
  }
  return t;
}
